import { motion } from 'framer-motion';
import { Plus, Pill, Heart, Sparkles } from 'lucide-react';

const SHAPES = [
  { Icon: Plus, cls: 'top-[12%] left-[6%] text-health-emerald bg-white', d: 0 },
  { Icon: Pill, cls: 'top-[62%] left-[3%] text-health-coral bg-white', d: 1.2 },
  { Icon: Heart, cls: 'top-[20%] right-[5%] text-health-coral bg-white', d: 0.6 },
  { Icon: Sparkles, cls: 'bottom-[10%] right-[8%] text-health-amber bg-white', d: 1.8 },
];

export const FloatingShapes = ({ className = '' }) => (
  <div className={`pointer-events-none absolute inset-0 ${className}`} aria-hidden="true">
    {SHAPES.map(({ Icon, cls, d }, i) => (
      <motion.span
        key={i}
        className={`absolute w-11 h-11 rounded-2xl shadow-soft flex items-center justify-center ${cls}`}
        animate={{ y: [0, -14, 0], rotate: [0, 8, -6, 0] }}
        transition={{ duration: 5 + i, repeat: Infinity, ease: 'easeInOut', delay: d }}
      >
        <Icon className="h-5 w-5" />
      </motion.span>
    ))}
  </div>
);

export default FloatingShapes;
